import { EVENT_TYPES as STANDARD_EVENT_TYPES } from '@stepstone/events-js';
import { modalActions } from './modalSlice.js';
import { FORM_TYPES } from '../../types/paramsConfig.js';
import { initCommonModalsDependencies } from '../../helpers/initCommonModalsDependencies.js';
const EVENT_TYPES = {
    ...STANDARD_EVENT_TYPES.CANDIDATE_PROFILE_EVENTS,
    INTERNAL_EVENTS: {
        SHOW_REGISTRATION_SUCCESS: 'INTERNAL_EVENTS_SHOW_REGISTRATION_SUCCESS',
        HIDE_REGISTRATION_SUCCESS: 'INTERNAL_EVENTS_HIDE_REGISTRATION_SUCCESS',
        SHOW_TWO_STEP_MODAL: 'INTERNAL_EVENTS_SHOW_TWO_STEP_MODAL',
        HIDE_TWO_STEP_MODAL: 'INTERNAL_EVENTS_HIDE_TWO_STEP_MODAL',
    },
};
export const getSubscriptionEvents = ({ showLoginModal, showTwoStepModal, showRegistrationModal, showResetPasswordModal, showFullscreenTwoStepModal, hideModal, }) => [
    {
        eventName: EVENT_TYPES.SHOW_LOGIN_MODAL,
        updateFunction: showLoginModal,
    },
    {
        eventName: EVENT_TYPES.HIDE_LOGIN_MODAL,
        updateFunction: hideModal,
    },
    {
        eventName: EVENT_TYPES.SHOW_REGISTRATION_MODAL,
        updateFunction: showRegistrationModal,
    },
    {
        eventName: EVENT_TYPES.HIDE_REGISTRATION_MODAL,
        updateFunction: hideModal,
    },
    {
        eventName: EVENT_TYPES.SHOW_RESETPASSWORD_MODAL,
        updateFunction: showResetPasswordModal,
    },
    {
        eventName: EVENT_TYPES.HIDE_RESETPASSWORD_MODAL,
        updateFunction: hideModal,
    },
    {
        eventName: EVENT_TYPES.INTERNAL_EVENTS.HIDE_REGISTRATION_SUCCESS,
        updateFunction: hideModal,
    },
    {
        eventName: EVENT_TYPES.INTERNAL_EVENTS.SHOW_TWO_STEP_MODAL,
        updateFunction: showTwoStepModal,
    },
    {
        eventName: EVENT_TYPES.INTERNAL_EVENTS.HIDE_TWO_STEP_MODAL,
        updateFunction: hideModal,
    },
    {
        eventName: EVENT_TYPES.SHOW_FULLSCREEN_RLA_MODAL,
        updateFunction: showFullscreenTwoStepModal,
    },
    {
        eventName: EVENT_TYPES.HIDE_FULLSCREEN_RLA_MODAL,
        updateFunction: hideModal,
    },
];
export const getUpdateFunctionsCustomEvent = (encodedGTLibraryUrl, logoBrandName, dispatch) => ({
    showLoginModal: ({ detail }) => {
        initCommonModalsDependencies(encodedGTLibraryUrl, logoBrandName, dispatch, detail);
        dispatch(modalActions.showModal(FORM_TYPES.LOGIN));
    },
    showTwoStepModal: ({ detail }) => {
        initCommonModalsDependencies(encodedGTLibraryUrl, logoBrandName, dispatch, detail);
        dispatch(modalActions.showModal(FORM_TYPES.BASIC_TWO_STEP));
    },
    showRegistrationModal: ({ detail, }) => {
        initCommonModalsDependencies(encodedGTLibraryUrl, logoBrandName, dispatch, detail);
        dispatch(modalActions.showModal(FORM_TYPES.REGISTRATION));
    },
    showResetPasswordModal: ({ detail, }) => {
        initCommonModalsDependencies(encodedGTLibraryUrl, logoBrandName, dispatch, detail);
        dispatch(modalActions.showModal(FORM_TYPES.RESET_PASSWORD));
    },
    showFullscreenTwoStepModal: ({ detail, }) => {
        initCommonModalsDependencies(encodedGTLibraryUrl, logoBrandName, dispatch, detail);
        dispatch(modalActions.showModal(FORM_TYPES.FULLSCREEN_TWO_STEP));
    },
});
export const getUpdateFunctionsPubSub = (encodedGTLibraryUrl, logoBrandName, dispatch) => ({
    showLoginModal: (_, payload) => {
        initCommonModalsDependencies(encodedGTLibraryUrl, logoBrandName, dispatch, payload);
        dispatch(modalActions.showModal(FORM_TYPES.LOGIN));
    },
    showTwoStepModal: (_, payload) => {
        initCommonModalsDependencies(encodedGTLibraryUrl, logoBrandName, dispatch, payload);
        dispatch(modalActions.showModal(FORM_TYPES.BASIC_TWO_STEP));
    },
    showRegistrationModal: (_, payload) => {
        initCommonModalsDependencies(encodedGTLibraryUrl, logoBrandName, dispatch, payload);
        dispatch(modalActions.showModal(FORM_TYPES.REGISTRATION));
    },
    showResetPasswordModal: (_, payload) => {
        initCommonModalsDependencies(encodedGTLibraryUrl, logoBrandName, dispatch, payload);
        dispatch(modalActions.showModal(FORM_TYPES.RESET_PASSWORD));
    },
    showFullscreenTwoStepModal: (_, payload) => {
        initCommonModalsDependencies(encodedGTLibraryUrl, logoBrandName, dispatch, payload);
        dispatch(modalActions.showModal(FORM_TYPES.FULLSCREEN_TWO_STEP));
    },
});
//# sourceMappingURL=eventsSubscriptions.js.map